import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <ContactSection />
        <TopicsSection />
        <FeaturesSection />
        <RankingSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <IndexSection />
        <MediaSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}